module.exports = "copy-paste"